
<template>
    <form class="kt-form">
        <kt-show-msg v-if="has_error" type="danger">
            <span v-bind:key="error" v-for="error in _errors">{{ error }}</span>
        </kt-show-msg>
        <slot></slot>
    </form>
</template>

<script>
export default {
    props: {
        errors: {
            type: Array,
            default: function() {
                return []
            }
        },
        has_error: {
            type: Boolean,
            default: false,
        }
    },
    components: {
    },
    computed: {
        _errors: function() {
            return this.errors[0] ? this.errors[0] : []
        }
    }
}
</script>